<template>
  <div id="all">
    <ccd-header></ccd-header>
    <div class="clear"></div>

    <div id="content">
      <ccd-breadcrumb :acselecionada="acSelecionada" :pscselecionado="pscSelecionado" :menuselecionado="menuSelecionado"></ccd-breadcrumb>

      <div class="middle">
        <ccd-menu></ccd-menu>

        <div id="leitura">
          <keep-alive>
            <component :is="menuSelecionado" :acselecionada="acSelecionada" :pscselecionado="pscSelecionado"></component>
          </keep-alive>

          <br><br>

          <a @click="carregarACS" style="font-size: x-small;">Atualizar ACs</a>
          |
          <a @click="carregarARS" style="font-size: x-small;">Atualizar ARs</a>
          |
          <a @click="carregarAcordos" style="font-size: x-small;">Atualizar Acordos Operacionais</a>
        </div>

        <ccd-menudireita></ccd-menudireita>

      </div>

      <div class="footer"></div>
    </div> <!-- content -->

    <ccd-footer></ccd-footer>
  </div>
</template>

<script>
  import Menu from './components/Menu.vue';
  import MenuDireita from './components/MenuDireita.vue';
  import Home from './components/Home.vue';
  import Tipos from './components/Tipos.vue';
  import Breadcrumb from './components/Breadcrumb.vue';
  import Header from './components/Header.vue';
  import Footer from './components/Footer.vue';
  import Repositorio from './components/Repositorio.vue';
  import RepositorioPSC from './components/RepositorioPSC.vue';
  import Servicos from './components/Servicos.vue';
  import Manuais from './components/Manuais.vue';
  import Selo from './components/Selo.vue';

  import { EventBus } from './main';

  export default {
    data() {
      return {
        menuSelecionado: 'ccd-home',
        acSelecionada: null,
        pscSelecionado: null
      }
    },
    components: {
      'ccd-menu': Menu,
      'ccd-menudireita': MenuDireita,
      'ccd-home': Home,
      'ccd-breadcrumb': Breadcrumb,
      'ccd-tipos': Tipos,
      'ccd-header': Header,
      'ccd-footer': Footer,
      'ccd-repositorio': Repositorio,
      'ccd-repositorio-psc': RepositorioPSC,
      'ccd-servicos': Servicos,
      'ccd-manuais': Manuais,
      'ccd-selo': Selo,
    },
    methods: {
      carregarACS() {
        /**
          CARREGAR LISTA DE AC'S
        */
        console.log('Carregando lista de ACs...');
        this.$http.get('./acs.json')
          .then(response => {
            return response.json();
          }, error => {
            alert('Erro ao carregar lista de ACs');
            console.log(error);
          })
          .then(data => {
            EventBus.acs = data;
            console.log('Lista de ACs carregada');

            if( EventBus.acs[ this.acSelecionada ] ) {
              this.menuSelecionado = 'ccd-repositorio';
            }

          }, error => {
            alert('Erro ao processar lista de ACs');
            console.log(error);
          });
      },
      carregarARS() {
        /**
          CARREGAR LISTA DE AR'S
        */
        console.log('Carregando lista de ARs...');
        this.$http.get('./ars.json')
          .then(response => {
            return response.json();
          }, error => {
            // alert('Erro ao carregar lista de ARs');
            console.log(error);
          })
          .then(data => {
            EventBus.ars = data;
            console.log('Lista de ARs carregada');
          }, error => {
            alert('Erro ao processar lista de ARs');
            console.log(error);
          });
      },
      carregarAcordos() {
        /**
          CARREGAR LISTA DE ACORDOS OPERACIONAIS
        */
        console.log('Carregando lista de AOPs...');
        this.$http.get('./acordos.json')
          .then(response => {
            return response.json();
          }, error => {
            // alert('Erro ao carregar lista de AOPs');
            console.log(error);
          })
          .then(data => {
            EventBus.acordos = data;
            console.log('Lista de AOPs carregada');
          }, error => {
            alert('Erro ao processar lista de AOPs');
            console.log(error);
          });
      },
      carregarPSCS() {
        /**
          CARREGAR LISTA DE PSC'S
        */
        console.log('Carregando lista de PSCs...');
        this.$http.get('./pscs.json')
          .then(response => {
            return response.json();
          }, error => {
            // alert('Erro ao carregar lista de PSCs');
            console.log(error);
          })
          .then(data => {
            EventBus.pscs = data;
            console.log('Lista de PSCs carregada');

            if( EventBus.pscs[ this.pscSelecionado ] ) {
              this.menuSelecionado = 'ccd-repositorio-psc';
            }


          }, error => {
            alert('Erro ao processar lista de PSCs');
            console.log(error);
          });
      }
    },
    created() {
      /**
        LISTENERS
      */

      // Seleção do módulo principal
      EventBus.$on('mudarSelecao', (selecao) => {
        this.menuSelecionado = selecao;
        this.$router.push('/' + selecao.substr(4));
      });

      // Trocar AC selecionada para repositório
      EventBus.$on('mudarAC', (selecao) => {
        this.acSelecionada = selecao;
        console.log('AC: ' + selecao);
        this.menuSelecionado = 'ccd-repositorio';
        this.$router.push('/'+this.acSelecionada);
      });

      // Trocar PSC selecionado para repositório
      EventBus.$on('mudarPSC', (selecao) => {
        this.pscSelecionado = selecao;
        console.log('PSC: ' + selecao);
        this.menuSelecionado = 'ccd-repositorio-psc';
        this.$router.push('/'+this.pscSelecionado);
      });

      // Ajustar controller pela  URL
      // @TODO: Refatorar para usar rotas
      switch (this.$route.path) {
        case '/tipos':
          this.menuSelecionado = 'ccd-tipos';
          break;
        case '/servicos':
          this.menuSelecionado = 'ccd-servicos';
          break;
        case '/manuais':
          this.menuSelecionado = 'ccd-manuais';
          break;
        case '/selo':
          this.menuSelecionado = 'ccd-selo';
          break;
        default:
          this.menuSelecionado = 'ccd-home';
          if( this.$route.path.substr(0,4) == '/ac_' ) {
            this.acSelecionada = this.$route.path.substr(1);
            console.log("AC PATH: " + this.$route.path.substr(1) );
          } else if( this.$route.path.substr(0,5) == '/psc_' ) {
            this.pscSelecionado = this.$route.path.substr(1);
          }
      }

      // Processar lista de ACs, ARs e AOPs
      this.carregarACS();
      this.carregarARS();
      // this.carregarAcordos();
      // this.carregarPSCS();

    }
  }
</script>



<style>

body {
    margin: 0px;
    background:url(./assets/bg.jpg) repeat-x top;
}
body,td,th {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    color: #55504e;
}


* {margin:0; padding:0; border:none; list-style:none; outline:none;}

a {color:#38a383; text-decoration:none; cursor: pointer;}
a:hover {color:#55504e; text-decoration:none;}

div#all {
    width:auto;
    background: url(./assets/bg_topo.jpg) no-repeat top center;
}
div.clear {clear:both;}

div#destaques {
    width:auto;
    overflow:hidden;
    background:url(./assets/bg_meio_home.jpg) no-repeat bottom;
    border-bottom:1px solid #fff;
}
div#destaques .meio {
    width:980px;
    margin:0 auto 0 auto;
    overflow:hidden;
    padding:15px 0 20px 0;
}
h2 {
    font-size:23px;
    color:#276955;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    padding:0 0 10px 0;
    margin:0 0 20px 0;
}
h2 img {
    float:left;
    margin:0 10px 0 0;
}

div#prod-destaques {
    width:305px;
    float:left;
}
div#serv-destaques {
    width:305px;
    float:left;
    margin:0 0 0 30px;
}
div#solu-destaques {
    width:305px;
    float:right;
}

ul.list-dest {
    width:305px;
    float:left;
    margin:0 0 5px 0;
}
ul.list-dest li {
    float:left;
}
ul.list-dest li.thumb {
    width:90px;
    height:88px;
    background:url(./assets/img_balao.png) no-repeat;
    margin:0 10px 0 0;
    padding:13px 0 0 14px;
}
ul.list-dest li.titulo {
    width:190px;
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
    padding:5px 0 5px 0;
}
ul.list-dest li.titulo a {
    color:#2e9677;
    text-decoration:none;
}
ul.list-dest li.titulo a:hover {
    color:#55504e;
}

ul.list-dest li.chamada {
    width:190px;
}
ul.list-solu {
    width:305px;
    float:left;
}
ul.list-solu li {
    width:305px;
    float:left;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    padding:6px 0 6px 0;
}
ul.list-solu li span {
    width:305px;
    float:left;
    font-size:11px;
}
ul.list-solu li a {
    float:left;
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
    text-decoration:none;
}
ul.list-solu li a:hover {
    color:#55504e;
}
div#box-inferior {
    width:980px;
    margin:0 auto 0 auto;
    padding:25px 0 0 0;
    overflow:hidden;
}
div#box-inferior .um #serv-destaques {
    margin:0 0 30px 0 !important;
}
div#box-inferior .um {
    width:335px;
    float:left;
}
div#box-inferior .um h3 {
    width:287px;
    color:#38a383;
    font-size:20px;
    padding:15px 0 10px 0;
}
div#box-inferior .um h3 a {
    color:#2e9677;
    text-decoration:none;
    font-weight:bold;
}
div#box-inferior .um h3 a:hover {
    color:#55504e;
}
div#box-inferior .um p {
    width:287px;
}
div#box-inferior .dois {
    width:305px;
    float:left;
}
div#box-inferior .dois h2 {
    margin:0;
}
ul.list-donwloads {
    width:305px;
    float:left;
    margin:0 0 20px 0;
}
ul.list-donwloads li {
    width:295px;
    float:left;
    padding:10px 10px 0 0;
    background: url(./assets/icon_download.png) no-repeat right;
}
ul.list-donwloads li a {
    color:#2e9677;
    text-decoration:none;
    font-weight:bold;
}
ul.list-donwloads li a:hover {
    color:#55504e;
}
ul.list-donwloads li span {
    width:305px;
    float:left;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    padding:0 0 10px 0;
}
div#box-inferior .dois p {
    width:305px;
    float:left;
    padding:15px 0 15px 0;
}
div#box-inferior .dois a {
    color:#2e9677;
    text-decoration:none;
    font-weight:bold;
}
div#box-inferior .dois a:hover {
    color:#55504e;
}
div#box-inferior .tres {
    width:305px;
    float:right;
}
div#box-inferior .tres h2 {
    margin:0;
}
div#box-inferior .tres ul.list-donwloads li {
    background:none;
}

div.logos {
    width:640px;
    float:left;
    background:url(./assets/sombra.png) no-repeat top center;
}
div.logos img {
    margin:55px 0 35px;
}

div#box-inferior .tres .mais {
    width:295px;
    float:left;
    text-align:right;
    font-weight:bold;
    padding:0 10px 0 0;
}

/* ALTERAÇÕES PARA E-COMMERCE */

div#venda-infos {
    width:280px;
    float:left;
}
div#venda-infos h4 {
    font-size:23px;
    color:#276955;
    padding:0 0 0 65px;
    height: 60px;
}
div#venda-infos h4 span {
    font-weight:normal;
}
div#venda-destaques {
    width:700px;
    float:left;
}
div#venda-destaques .mais {
    width:700px;
    float:left;
}
div#venda-destaques .mais a {
    float:right;
    font-size:18px;
}
ul.venda-prod {
    width:320px;
    float:left;
    margin:10px 0 10px 30px;
}
ul.venda-prod li {
    float:right;
    width: 205px;
}
ul.venda-prod li.thumb {
    width:90px;
    height:88px;
    background:url(./assets/img_balao.png) no-repeat;
    margin:0 10px 0 0;
    padding:13px 0 0 14px;
    float: left;
}
ul.venda-prod li.titulo {
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
    padding:5px 0 0 0;
}
ul.venda-prod li.titulo a {
    color:#2e9677;
    text-decoration:none;
}
ul.venda-prod li.titulo a:hover {
    color:#55504e;
}
ul.venda-prod li.valor {
    margin:10px 0 0 0;
    font-weight:bold;
}
ul.venda-prod li.valor span {
    color:#d62901;
    padding:0 0 0 5px;
}
ul.venda-prod li.valor img {
    float:right;
}
ul.menu-infos {
    width:253px;
    height:145px;
    float:left;
    background:url(./assets/bg_infos.png) no-repeat;
    padding:20px 0 0 20px;
}
ul.menu-infos li {
    width:230px;
    color:#2e9677;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    padding:8px 0;
    font-weight:bold;
}
ul.menu-infos li.ultimo { background: none; }
ul.menu-infos li img {
    margin:0 5px 0 0;
}
ul.menu-infos li.titulo {
    font-size:14px;
    color:#276955;
    padding:10px 0 12px 0;
}

ul.renove {
    width:273px;
    height:70px;
    float:left;
    background:url(./assets/bg_renove.png) no-repeat;
}
ul.renove li {
    padding: 13px 0 0 20px;
}
ul.renove li a {
    color: #fff;
    font-size: 16px;
    text-decoration: none;
    line-height: 45px;
    font-weight: normal;
}
ul.renove li a:hover { text-decoration: none; color: #fff; }


/* HEADER */

div#header {
    width:980px;
    padding:0 10px 0 10px;
    margin:0 auto 0 auto;
}
div#header .logo {
    margin:25px 0 0 0;
    float:left;
}
div#header #fone {
    width:235px;
    height:71px;
    float:left;
    padding:20px 0 0 135px;
  /*  background:url(../images/separador.png) no-repeat right; */
    margin:12px 0 0 0;
}
div#header #fone img {
    float:left;
    margin:5px 15px 15px 0;
}
div#header #fone span {
    width:160px;
    float:left;
    font-size:11px;
    color:#217b60;
    padding:5px 0;
    margin-top: 2px;
}
div#header #fone div {
    width:150px;
    float:left;
    color:#2e9677;
    font-size:23px;
    margin-bottom: 15px;
}
div#header #menu-superior {
    width:330px;
    float:left;
    padding:15px 0 0 25px;
}
div#header #menu-superior a {
    color:#2e9677;
    font-weight:bold;
    text-decoration:none;
    margin:0 15px 0 0;
}
div#header #menu-superior a:hover {
    color:#55504e;
}
div#header #socialmedia {
    width:130px;
    float:left;
    padding:25px 0 0 25px;
}
div#header #socialmedia img {
    margin:0 10px 0 0;
}
div#header .busca {
    width:231px;
    height:49px;
    float:left;
    /*background:url(../images/bg_busca.png) no-repeat;*/
    margin:20px 0 0 0;
}
div#header .busca input {
    width:175px;
    background-color:transparent;
    float:left;
    padding:10px;
    color:#FFF;
    font-size:11px;
}
div#header .busca input.bt {
    width:35px;
    height:33px;
    padding:0;
    cursor: pointer;
}
div#header ul#menu-principal {
    width:980px;
    height:45px;
    float:left;
    margin:16px 0 30px 0;
}
div#header ul#menu-principal li {
    height:45px;
    line-height:45px;
    float:left;
    font-size:15px;
    font-weight:bold;
    position:relative;
    margin:0 20px 0 0;
}
div#header ul#menu-principal li a {
    color:#276955;
    text-decoration:none;
    height:45px;
    padding:0 10px 0 10px;
}
div#header ul#menu-principal li:hover a {
    background-color:#38a383;
    color:#fff;
    display:block
}
div#header ul#menu-principal li ul {
    width:183px;
    background-color:#38a383;
    display:none;
    z-index:2;
    position:absolute;
}
div#header ul#menu-principal li ul li {
    width:183px;
    background:none;
    font-size:12px;
    margin:0 !important;
    height:25px;
    line-height:25px;
}
div#header ul#menu-principal li ul li a {
    padding:0 0 0 10px !important;
    height:25px !important;
}
div#header ul#menu-principal li ul li:hover a {
    background-color:#47b695;
    color:#fdf86c;
    display:block;
}
div#header ul#menu-principal li.atual {
    background-color:#38a383;
    color:#fff;
    padding:0 10px 0 10px;
}

div#header ul#menu-principal li div.certificado {
    display: none;
    width: 425px;
    /*background: #38a383 url('../images/menu_certificado_carrinho.png') no-repeat 12px 17px;*/
    position: absolute;
    z-index: 15;
    padding: 15px 0 15px 70px;
}
div#header ul#menu-principal li div.certificado ul {
    display: inline;
    position: static;
    float: left;
    background: none;
    width: 150px;
    margin: 0 15px;
}
div#header ul#menu-principal li div.certificado ul.cat {
    border-right: 1px solid #3cb591;
    margin-right: 0;
    padding-right: 15px;
    width: 94px;
}
div#header ul#menu-principal li div.certificado ul.cat li { width: 94px; }
div#header ul#menu-principal li div.certificado ul li {
    background: none;
    border-bottom: 1px solid #32c196;
    width: 150px;
    height: auto;
    line-height: 25px;
    font-weight: normal;
}
div#header ul#menu-principal li div.certificado ul li a {
    display: inline;
    padding: 0 !important;
}
div#header ul#menu-principal li div.certificado ul li:hover a { background: none; }
div#header ul#menu-principal li div.certificado ul li.titulo {
    font-size: 14px;
    padding: 5px 0 15px;
    line-height: 14px;
}
div#header ul#menu-principal li div.certificado ul li.amarelo { color: #fdf86c; }
div#header ul#menu-principal li div.certificado a.btn_renove {
    float: right;
    width: 107px;
    height: 42px;
    padding: 0;
    margin-right: 12px;
    /*background: url('../images/btn_renove.png') no-repeat top center;*/
}


div#banner-rotativo {
    width:1000px;
    margin:0 auto 0 auto;
    position:relative;
}
div#banner-rotativo .img {
    width:980px;
    height:327px;
    margin:0 auto 0 auto;
    z-index: 1;
}
div#banner-rotativo .pag-banner {
    width:990px;
    height:85px;
    position:absolute;
    /*background:url(../images/bg_pag.png) no-repeat bottom;*/
    bottom:0;
    z-index:1;
    padding:0 0 0 10px;
}
div#banner-rotativo .pag-banner li {
    height:75px;
    float:left;
    /*background:url(../images/bg_pag_li.png) no-repeat bottom right;*/
    color:#fff;
    font-size:13px;
}
div#banner-rotativo .pag-banner li a {
    height:39px;
    float:left;
    padding:14px 20px 0 20px;
    /*background:url(../images/linha.png) repeat-y right top;*/
    margin:22px 0 0 0;
    color:#fff;
    text-decoration:none;
}
div#banner-rotativo .pag-banner li a:hover {
    color:#fdf86c;
}
div#banner-rotativo .pag-banner li a span {
    font-size:22px;
    padding:0 5px 0 0;
}
div#banner-rotativo .pag-banner li.activeSlide {
    /*background: url(../images/marcador.png) no-repeat 17px 5px;*/
}
div#banner-rotativo .pag-banner li.activeSlide span {
    color:#fdf86c;
}

/* Content */

div#content {
    width:980px;
    margin:0 auto 20px auto;
    overflow:hidden;
}
div#content .top {
    width:980px;
    height:35px;
    float:left;
    background:url(./assets/topo_content.png) no-repeat;
}
div#content #caminho {
    width:699px;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    padding:10px 0 10px 0;
    margin:0 0 0 12px;
    font-size:11px;
}
div#content #caminho a {
    margin:0 5px 0 5px;
}
div#content #caminho span {
    padding:0 0 0 5px;
    font-weight:bold;
}
div#content .middle {
    width:980px;
    float:left;
    background:url(./assets/meio_content.png) repeat-y;
    padding:0 0 20px 0;
}
div#content .footer {
    width:980px;
    height:8px;
    float:left;
    background: url(./assets/rodape_content.png) no-repeat;
}
ul#menu-interno {
    width:205px;
    float:left;
    margin:20px 0 0 2px;
}
ul#menu-interno li {
    width:190px;
    /*height:26px;*/
    float:left;
    background:url(./assets/bg_menu.png) repeat-y;
    margin:0 0 2px 0;
    line-height:24px;
    padding:0 0 0 10px;
}
ul#menu-interno li a {
    color:#38a383;
    font-weight:bold;
    text-decoration:none;
}
ul#menu-interno li a:hover {
    color:#55504e;
}
ul#menu-interno li.atual {
    font-weight:bold;
}
div#leitura {
    width:485px;
    float:left;
    background:url(./assets/sombra_leitura.png) no-repeat left top;
    padding:0 0 0 29px;
}
div#leitura h1 {
    width:485px;
    float:left;
    color:#406c5f;
    font-size:30px;
    font-weight:bold;
    padding:20px 0 20px 0;
}
div#leitura h4 {
    width:470px;
    float:left;
    color:#406c5f;
    font-size:18px;
    font-weight:bold;
    padding:20px 0 10px 0;
}
div#leitura img {
    border:1px solid #e2e2e2;
}
div#leitura .texto {
    width:470px;
    float:left;
    font-size:13px;
    padding:20px 0 0 0;
    line-height:20px;
}
div#leitura .texto .img-case {
    float:left;
    padding:20px;
    border:1px solid #e2e2e2;
    margin:5px 20px 0 0;
}
div#leitura .texto .img-case img {
    border:none;
}
div#lateral {
    width:233px;
    float:right;
    padding:0 12px 0 0;
}
div#lateral h2 {
    margin:0;
}
ul#interacao {
    width:485px;
    float:left;
    padding:10px 0 0 0;
}
ul#interacao li {
    float:left;
}
ul#interacao li img {
    float:left;
    border:none;
    margin:0 5px 0 0;
}
ul#interacao li a {
    float:left;
    font-size:11px;
    margin:2px 15px 0 0;
}
ul#interacao li a span { display: none; }
ul#interacao li.right {
    float:right;
    padding:0 10px 0 0;
}
ul#interacao li.right a {
    margin:0;
}
ul.lista-unidades {
    width:233px;
    float:left;
}
ul.lista-unidades li {
    width:233px;
    float:left;
    padding:5px 0 10px 0;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
}
ul.lista-unidades li p {
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
}
ul.lista-unidades li.mais {
    background:none;
    padding:10px 0 0 0;
}
ul.lista-unidades li.mais img {
    float:left;
    margin:1px 4px 0 0;
}
ul.lista-unidades li.mais a {
    color:#276955;
    font-weight:bold;
}
ul.lista-unidades li.mais a:hover {
    color:#38a383;
}
ul.lista-unidades li.valor {
    width:200px;
    margin:10px 0 0 0;
    font-weight:bold;
}
ul.lista-unidades li.valor span {
    color:#d62901;
    padding:0 0 0 5px;
}
ul.lista-unidades li.valor img {
    float:right;
}

div#box-banner {
    width:233px;
    float:left;
    padding:20px 0 0 7px;
}
div#box-banner img {
    margin:0 0 15px 0;
}
div#box-certificado {
    width:233px;
    float:left;
    padding:20px 0 0 0;
}
div#box-certificado img {
    float:left;
}
div#box-certificado h3 {
    float:left;
    font-size:18px;
    padding:15px 0 5px 0;
}
div#box-certificado p {
    float:left;
}
ul.lista-faq {
    width:233px;
    float:left;
}
ul.lista-faq li {
    width:233px;
    float:left;
    padding:5px 0 10px 0;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    font-weight:bold;
}
ul.lista-faq li.mais {
    background:none;
    padding:10px 0 0 0;
}
ul.lista-faq li.mais img {
    float:left;
    margin:1px 4px 0 0;
}
ul.lista-faq li.mais a {
    color:#276955;
}
ul.lista-faq li.mais a:hover {
    color:#38a383;
}
ul.lista-infos {
    width:233px;
    float:left;
    margin:0 0 15px 0;
}
ul.lista-infos li {
    width:233px;
    float:left;
    padding:5px 0 10px 0;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    font-weight:bold;
}
ul.lista-infos li img {
    margin:0 5px 0 0;
}
div#conteudo {
    width:700px;
    float:left;
    padding:0 0 0 10px;
}
div#conteudo h1 {
    width:690px;
    float:left;
    color:#406c5f;
    font-size:30px;
    font-weight:bold;
    padding:20px 0 20px 10px;
}
div#conteudo .intro {
    width:690px;
    float:left;
    padding:0 0 25px 10px;
}
div#conteudo .texto {
    width:680px;
    float:left;
    padding:0 0 0 10px;
    line-height:17px;
}
div#conteudo .texto strong, b {
    color:#406c5f;
    font-size:14px;
    font-weight:bold;
}
div#conteudo .texto ul { padding-left: 20px; float: left; }
div#conteudo .texto ul li { list-style: disc; }

div#conteudo #interacao {
    width:700px;
}
div#conteudo #interacao li.right {
    padding:0;
}
div#conteudo .texto .thumb {
    width:277px;
    height:234px;
    background:url(./assets/bg_thumb.png) no-repeat;
    float:left;
    margin:0 20px 5px 0;
}
div#conteudo .texto .thumb img {
    margin:18px 0 0 15px;
    border:1px solid #f1f1f1;
}
ul.listas {
    width:295px;
    float:left;
    margin:0 26px 20px 26px;
}
ul.listas li {
    float:left;
}
ul.listas li.thumb {
    width:90px;
    height:88px;
    background:url(./assets/img_balao2.png) no-repeat;
    margin:0 10px 0 0;
    padding:13px 0 0 14px;
}
ul.listas li.titulo {
    width:175px;
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
    padding:5px 0 5px 0;
}
ul.listas li.titulo a {
    color:#2e9677;
    text-decoration:none;
}
ul.listas li.titulo a:hover {
    color:#55504e;
}

ul.listas li.chamada {
    width:175px;
    color:#8f9997;
}
div#box-solucoes {
    width:233px;
    float:left;
    background: url(./assets/bg_solucoes.png) repeat-y;
    padding:15px 0 15px 0;
    margin:20px 0 20px 0;
}
ul.lista-solucoes {
    width:233px;
    float:left;
}
ul.lista-solucoes li {
    width:233px;
    float:left;
    padding:10px 0 10px 0;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
}
ul.lista-solucoes li span {
    width:233px;
    float:left;
    font-size:11px;
}
ul.lista-solucoes li a {
    font-size:16px;
    font-weight:bold;
}
ul.lista-solucoes li.mais {
    background:none;
    padding:10px 0 0 0;
}
ul.lista-solucoes li.mais a {
    color:#276955;
    font-weight:bold;
    font-size:12px;
}
ul.lista-solucoes li.mais a:hover {
    color:#38a383;
}
ul.lista-solucoes li.mais img {
    float:left;
    margin:1px 4px 0 0;
}
ul.lista-downloads {
    width:475px;
    float:left;
    margin:0 0 15px 0;
}
ul.lista-downloads li a {
    font-size:13px;
    font-weight:bold;
}
ul.lista-downloads li span {
    width:445px;
    float:left;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    padding:0 0 10px 0;
    margin:0 0 8px 0;
}
ul.lista-downloads li {
    width:445px;
    background:url(./assets/icon_download.png) no-repeat 0 8px;
    padding:0 0 0 30px;
    float:left;
    color:#9ca9a6;
}
ul.lista-downloads li.prod {
    width:465px;
    color:#406c5f;
    font-size:16px;
    background:url(./assets/bg_menu.png) repeat-y left;
    font-weight:bold;
    padding:5px 0 5px 10px;
    margin:0 0 10px 0;
}
ul.lista-videos {
    width:470px;
    float:left;
    margin:0 0 10px 0;
}
ul.lista-videos li {
    float:left;
}
ul.lista-videos li.thumb {
    width:90px;
    height:88px;
    background:url(./assets/img_balao2.png) no-repeat;
    margin:0 10px 0 0;
    padding:13px 0 0 14px;
}
ul.lista-videos li.titulo {
    width:350px;
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
    padding:5px 0 5px 0;
}
ul.lista-videos li.titulo a {
    color:#2e9677;
    text-decoration:none;
}
ul.lista-videos li.titulo a:hover {
    color:#55504e;
}
ul.lista-videos li.chamada {
    width:350px;
}
div.visualizar {
    width:450px;
    float:left;
    border:1px solid #e2e2e2;
    padding:10px;
    background-color:#f9f9f9;
}
div.marcas {
    width:470px;
    min-height:500px;
    float:left;
}
div.marcas p {
    float:left;
    padding:0 0 25px 0;
}
div.marcas p.erro { float: none; padding: 0; color: #C00910; }
div.marcas p.sucesso { float: none; padding: 0; color: #38A383; }
div.marcas img {
    float:left;
    margin:0 12px 24px 12px;
    border:1px solid #e2e2e2;
}

ul.lista-cases {
    width:470px;
    float:left;
    margin:0 0 15px 0;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    padding:0 0 15px 0;
}
ul.lista-cases li {
    float:left;
}
ul.lista-cases li.thumb {
    width:130px;
    height: 72px;
    margin:0 15px 0 0;
    position:relative;
    overflow: hidden;
}
ul.lista-cases li img.player {
    position:absolute;
    z-index:1;
    border:none !important;
    margin:18px 0 0 40px !important;
}
ul.lista-cases li.thumb img {
    margin:0;
    float:none;
}
ul.lista-cases .titulo {
    width:315px;
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
}
ul.lista-cases li.titulo a {
    color:#2e9677;
    text-decoration:none;
}
ul.lista-cases li.titulo a:hover {
    color:#55504e;
}
ul.lista-cases .resumo {
    width:315px;
    color:#8F9997;
}

/* paginacao */
.pag-albuns {
    float:left;
    list-style:none;
}
.pag-albuns li {
    float:left;
    background-color:#fff;
    color:#38A383;
    margin:0 10px 0 0;
    font-weight: bold;
    width: auto !important;
    padding: 0 !important;
    background: none !important;
}
.pag-albuns li.atual { color: #55504E; }
.pag-albuns li a { color: #55504E; font-size: 12px !important; }

ul.unidades {
    width:470px;
    float:left;
    padding:0 0 15px 0;
}
ul.unidades li {
    width:470px;
    float:left;
    padding:5px 0 10px 0;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    color:#8f9997;
}
ul.unidades li span {
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
    margin:0;
    padding:0;
    display: block;
}
ul.unidades li p { margin: 0; padding: 0; float: none; }
form.parceiro {
    width:470px;
    float:left;
}
form.parceiro label {
    width:470px;
    float:left;
    padding:0 0 10px 0;
    font-weight:bold;
}
form.parceiro label input {
    border-top:1px solid #d3d3d3;
    border-left:1px solid #d3d3d3;
    border-right:1px solid #f1f1f1;
    border-bottom:1px solid #f1f1f1;
    background-color:#f9f9f9;
    padding:4px;
    color:#38a383;
    margin:3px 0 0 0;
}
form.parceiro label textarea {
    border-top:1px solid #d3d3d3;
    border-left:1px solid #d3d3d3;
    border-right:1px solid #f1f1f1;
    border-bottom:1px solid #f1f1f1;
    background-color:#f9f9f9;
    padding:4px;
    color:#38a383;
    margin:3px 0 0 0;
    font-family:Arial, Helvetica, sans-serif;
    font-size:13px;
}
form.parceiro label input.bt {
    background-color:#38A383;
    color:#fff;
    border:none;
    cursor: pointer;
}
form.parceiro h3 {
    margin:0;
    padding:0;
    float:left;
    padding:0 0 15px 0;
    font-size:16px;
}
div#localizacao {
    width:470px;
    float:left;
}
div#localizacao p { float: none; padding: 0; width: auto; }
div#localizacao h3 { float: none; }
ul.faq {
    width:470px;
    float:left;
}
ul.faq li {
    width:470px;
    float:left;
    /*background:url(./assets/linha.jpg) repeat-x bottom;*/
    padding:5px 0 5px 0;
    font-weight:bold;
}
ul.faq li.atual {
    font-weight:bold;
    font-size:14px;
}
ul.faq li.resposta {
    width:450px;
    background-color:#f7f7f7;
    padding:10px;
    font-weight:normal;
}
ul.faq li span {
    color:#8cc921;
    font-size:11px;
}
ul.faq li.mais {
    background:none;
}
ul.faq li.mais img {
    float:left;
    margin:0 5px 0 0;
}
ul.faq li.mais span {
    float:left;
}

ul.lista-novidades {
    width:680px;
    float:left;
    margin:0 0 20px 10px;
}
ul.lista-novidades li {
    width:680px;
    float:left;
    padding:10px 10px 0 0;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
}
ul.lista-novidades li a {
    color:#2e9677;
    text-decoration:none;
    font-weight:bold;
    font-size:14px;
    font-weight:bold;
}
ul.lista-novidades li a:hover {
    color:#55504e;
}
ul.lista-novidades li span {
    width:680px;
    float:left;
    padding:5px 0 10px 0;
}
ul.lista-novidades li strong {
    color:#999;
    padding:0 5px 0 0;
}
ul.lista-novidades .pag-albuns { margin-top: 15px; }

/* ALTERAÇÕES PARA E-COMMERCE */

.topo {
    float:left;
    margin:10px 0 0 2px;
}
ul.venda-categorias {
    width:660px;
    float:left;
    margin:0 26px 20px 20px;
    position:relative;
}
ul.venda-categorias li {
    float:left;
}
ul.venda-categorias li.thumb {
    width:90px;
    height:88px;
    background:url(./assets/img_balao2.png) no-repeat;
    margin:0 10px 0 0;
    padding:13px 0 0 14px;
}
ul.venda-categorias li.titulo {
    width:380px;
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
    padding:5px 0 5px 0;
}
ul.venda-categorias li.titulo a {
    color:#2e9677;
    text-decoration:none;
}
ul.venda-categorias li.titulo a:hover {
    color:#55504e;
}
ul.venda-categorias li.chamada {
    width:380px;
    color:#8f9997;
}
ul.venda-categorias li.bt {
    height:88px;
    line-height:88px;
    position:absolute;
    right:0;
    padding:0 0 0 20px;
    background:url(./assets/separador.png) no-repeat left;
}

div.lista-certificado {
    width: 660px;
    /*background: url('lista_certificados.jpg') repeat-y top left;*/
    margin: 0 0 15px 10px;
    padding: 10px;
}
div.lista-certificado ul.detalhe {
    width:505px;
    float:left;
}
div.lista-certificado ul.detalhe li {
    float:right;
    width: 385px;
}
div.lista-certificado ul.detalhe li.thumb {
    width:90px;
    height:88px;
    background:url(./assets/img_balao2.png) no-repeat;
    margin:0 15px 0 0;
    padding:13px 0 0 14px;
    float: left;
}
div.lista-certificado ul.detalhe li.titulo {
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
    padding:5px 0 0 0;
}
div.lista-certificado ul.detalhe li.titulo a {
    color:#2e9677;
    text-decoration:none;
}
div.lista-certificado ul.detalhe li.titulo a:hover {
    color:#55504e;
}

div.lista-certificado ul.valor {
    float: right;
    width: 100px;
    margin-top: 15px;
}
div.lista-certificado ul.valor li {
    display: block;
    margin-bottom: 5px;
    font-size: 11px;
    font-weight: bold;
    color: #406c5f;
}
div.lista-certificado ul.valor li span {
    font-size: 16px;
    color: #d62901;
}


div#conteudo .thumb-produto {
    width:277px;
    height:234px;
    /*background:url(img_produto.png) no-repeat;*/
    float:left;
    margin:20px 20px 5px 15px;
}
div#conteudo .thumb-produto img {
    margin:18px 0 0 15px;
}
div.detalhes-produto {
    width:370px;
    float:right;
    margin:20px 15px 0 0;
}
div.detalhes-produto h3 {
    color:#406c5f;
    font-size:25px;
    line-height:25px;
    margin:0 0 15px 0;
}
div.detalhes-produto .chamada {
    margin:0 0 20px 0;
}
div.detalhes-produto .valor {
    float:left;
    color:#d62901;
    font-size:20px;
    font-weight:bold;
}
div.detalhes-produto .valor span {
    color:#38a383;
    font-size:14px;
    font-weight:normal;
}
div.detalhes-produto .bt {
    float:right;
    margin:5px 0 0 0;
}
div.pagamento {
    width:370px;
    float:left;
    margin:15px 0 0 0;
    border-top:1px solid #e2e2e2;
    padding:10px 0 0 0;
}
ul.aba {
    width:400px;
    float:left;
    margin:20px 0 0 15px;
}
ul.aba li {
    color:#6c877f;
    font-size:13px;
    float:left;
    padding:8px;
    background-color:#eee;
    border:1px solid #e2e2e2;
    border-bottom: none;
    margin:0 5px 0 0;
    font-weight:bold;
    position: relative;
    height: 16px;
}
ul.aba li a { color: #6c877f; }
ul.aba li.atual {
    background-color:#fff;
    color:#406C5F;
    margin-bottom: -1px;
    height: 17px;
}
ul.aba li.atual a { color: #2e9677; }

div.compartilhar {
    float: right;
    margin: 28px 12px 0 0;
}

div.texto-aba {
    width:642px;
    float:left;
    border:1px solid #e2e2e2;
    margin:0 0 0 15px;
    padding:15px;
}
div.texto-aba ul { padding-left: 20px; }
div.texto-aba ul li { list-style: disc; }

ul.lista-relacionados {
    width:233px;
    float:left;
    background:url(./assets/linha_horizontal.jpg) repeat-x bottom;
    margin:0 0 10px 0;
}
ul.lista-relacionados li {
    width:233px;
    float:left;
    padding:5px 0 5px 0;
}
ul.lista-relacionados li p {
    color:#2e9677;
    font-size:16px;
    font-weight:bold;
}
ul.lista-relacionados li.valor {
    font-weight:bold;
}
ul.lista-relacionados li.valor span {
    color:#d62901;
    padding:0 0 0 5px;
}
ul.lista-relacionados li.valor img {
    float:right;
}

div#mapa {
    width:665px;
    float:left;
    padding:0 0 0 29px;
}
div#mapa h1 {
    width:665px;
    float:left;
    color:#406c5f;
    font-size:30px;
    font-weight:bold;
    padding:20px 0 20px 0;
}
div#mapa .texto {
    width:665px;
    float:left;
}
div#mapa .estados {
    width:550px;
    height:500px;
    /*background:url(mapa.jpg) no-repeat left;*/
    position:relative;
    margin:30px 0 0 50px;
}
div#mapa .estados a {
    position:absolute;
    color:#69A078;
    font-size:12px;
    font-weight:bold;
}
div#mapa .estados .RR {
    left:153px;
    top:35px;
}
div#mapa .estados .AP {
    left:275px;
    top:45px;
}
div#mapa .estados .AM {
    left:120px;
    top:120px;
}
div#mapa .estados .PA {
    left:260px;
    top:120px;
}
div#mapa .estados .AC {
    left:55px;
    top:190px;
}
div#mapa .estados .RO {
    left:130px;
    top:200px;
}
div#mapa .estados .MT {
    left:230px;
    top:230px;
}
div#mapa .estados .GO {
    left:295px;
    top:265px;
}
div#mapa .estados .MS {
    left:235px;
    top:320px;
}
div#mapa .estados .TO {
    left:320px;
    top:200px;
}
div#mapa .estados .MA {
    left:360px;
    top:120px;
}
div#mapa .estados .CE {
    left:435px;
    top:130px;
}
div#mapa .estados .PI {
    left:400px;
    top:160px;
}
div#mapa .estados .RN {
    right:13px;
    top:137px;
}
div#mapa .estados .PB {
    right:13px;
    top:155px;
}
div#mapa .estados .PE {
    right:13px;
    top:173px;
}
div#mapa .estados .AL {
    right:13px;
    top:190px;
}
div#mapa .estados .SE {
    right:13px;
    top:207px;
}
div#mapa .estados .DF {
    right:13px;
    top:262px;
}
div#mapa .estados .ES {
    right:13px;
    top:318px;
}
div#mapa .estados .RJ {
    right:13px;
    top:348px;
}
div#mapa .estados .SP {
    right:225px;
    top:345px;
}
div#mapa .estados .MG {
    right:170px;
    top:300px;
}
div#mapa .estados .BA {
    right:135px;
    top:220px;
}
div#mapa .estados .PR {
    right:265px;
    top:375px;
}
div#mapa .estados .SC {
    right:240px;
    top:410px;
}
div#mapa .estados .RS {
    right:275px;
    top:445px;
}

ul#filtro {
    width:170px;
    float:left;
    margin:10px 20px 0 15px;
}
ul#filtro li {
    width:190px;
    float:left;
    padding:5px 0 5px 0;
}
ul#filtro li.titulo {
    color:#276955;
    font-size:16px;
    background: url(./assets/linha_horizontal.jpg) repeat-x bottom;
    margin:0 0 10px 0;
    font-weight:bold;
}
ul#filtro li a {
    color:#38a383;
    font-weight:bold;
    text-decoration:none;
}
ul#filtro li a:hover {
    color:#55504e;
}
ul#filtro li.atual a {
    color:#55504e;
    font-weight:bold;
}

/* Footer */

div#footer {
    width:auto;
    height:402px;
    background:url(./assets/bg_footer.png) repeat-x top;
    overflow:hidden;
}
div#footer .meio {
    width:980px;
    margin:0 auto 0 auto;
    overflow:hidden;
    padding: 45px 0 0 0;
}
div#footer .ir-topo {
    float:left;
    margin:55px 0 0 0;
}
div#footer .parceiros {
    width:644px;
    height:128px;
    float:right;
    /*background:url(bg_logos.png) no-repeat;*/
}
div#footer .parceiros img.prev {
	float:left;
	margin:45px 5px 0 15px;
}
div#footer .parceiros img.next {
	float:right;
	margin:45px 15px 0 0;
}
div#footer .parceiros ul.marcas {
    width:585px;
    height:85px;
    float:left;
    padding:23px 0 0 0;
}
div#footer .parceiros ul.marcas li {
    float:left;
    margin:0 10px 0 10px;
}
div#footer .end {
    width:265px;
    float:left;
    color:#fff;
    padding:8px 0 0 0;
}
div#footer .end h4 {
    width:265px;
    float:left;
    font-size:16px;
    font-weight:bold;
    padding:0 0 15px 0;
}
div#footer .end p {
    padding:15px 0 15px 0;
}

div#footer .insti {
    width:230px;
    float:left;
    color:#FFF;
    padding:8px 0 0 0;
}
div#footer .insti h4 {
    width:230px;
    float:left;
    font-size:16px;
    font-weight:bold;
    padding:0 0 15px 0;
}
div#footer .insti ul {
    width:230px;
    float:left;
}
div#footer .insti ul li {
    width:230px;
    float:left;
    font-weight:bold;
    padding:0 0 5px 0;
}
div#footer .insti ul li a {
    color:#fff;
    text-decoration:none;
}
div#footer .insti ul li a:hover {
    color:#52ecbe;
}
form.news {
    width:230px;
    float:left;
    padding:8px 0 0 0;
    color:#FFF;
}
form.news h4 {
    width:230px;
    float:left;
    font-size:16px;
    font-weight:bold;
    padding:0 0 15px 0;
}
form.news div {
    width:223px;
    height:33px;
    float:left;
    /*background:url(input_news.png) no-repeat;*/
    margin:0 0 10px 0;
}
form.news div input {
    width:205px;
    background-color:transparent;
    height:33px;
    color:#55504e;
    font-size:11px;
    padding:0 0 0 10px;
    line-height: 33px;
}
form.news input.bt {
    width:53px;
    height:33px;
    /*background:url(bt_enviar.png) no-repeat;*/
    border:none;
    padding:0;
    cursor:pointer;
    margin:0;
    float:left;
    color:#FFF;
}
div#creditos {
    width:980px;
    float:left;
    padding:55px 0 0 0;
    color:#fff;
}
div#creditos .copy {
    float:left;
}
div#creditos .links {
    float:left;
    padding:0 0 0 50px;
}
div#creditos .links span {
    padding:0 5px 0 5px;
}
div#creditos .links a {
    color:#52ecbe;
    text-decoration:none;
}
div#creditos .links a:hover {
    color:#fff;
}
div#creditos .week {
    float:right;
}
div#creditos .week a {
    color:#fff;
    text-decoration:none;
    float:left;
    margin:0 10px 0 0;
}
div#creditos .week a:hover {
    color:#52ecbe;
}
div#creditos .week img {

}


</style>



// WEBPACK FOOTER //
// App.vue?5337ea27